import Component from './TreeNode.component';

export default Component;
